import { SpaceBetween, Toggle } from "@cloudscape-design/components";
import { Mode, Density } from "@cloudscape-design/global-styles";
import * as awsui from "@cloudscape-design/design-tokens";
import { Navbar, Link, Dropdown, Spacer, Backdrop } from "@nextui-org/react"; // https://nextui.org/docs/components/navbar
import { Layout } from "./layout";
import { HamburgerIcon, SettingsIcon, icons } from "./icons";
import headerLogoLight from "../../images/frg-header-logo-light.png";
import headerLogoDark from "../../images/frg-header-logo-dark.png";
import { GlobalContext } from "../../context";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import { NextUIProvider } from "@nextui-org/react"
import { nextUiTheme } from "../../theme";
import { useMediaQuery } from 'react-responsive';
import AuthContent from './auth-content';
import SettingsMenu from './settings-menu';
import NavLinks from './navbar-links';
import { navigateFn } from "../../routingHelper";
import { useAuthenticator } from '@aws-amplify/ui-react';

export default function TopNav() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme,
    density, setDensity,
    pathname, setPathname,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);
  const navbarToggleRef = useRef<any>()
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false)
  const { user, signOut, toSignIn, toSignUp } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  

  useEffect(()=> {
    if (location.pathname != "/signin"){
      setPathname(location.pathname)
    }
  }, [location]);


  // const [authContent, setAuthContent] = useState<any>(<></>)
  // const { user, signOut, toSignIn, toSignUp } = useAuthenticator((context) => [context.user]);


  // const isSmallDevice = useMediaQuery({query: "only screen and (max-width : 768px)"});
  // const isMediumDevice = useMediaQuery({query: "only screen and (min-width : 769px) and (max-width : 992px)"});
  // const isLargeDevice = useMediaQuery({query: "only screen and (min-width : 993px) and (max-width : 1200px)"});
  // const isDesktop = useMediaQuery({query: "only screen and (min-width : 1201px)"});
  const collapseNavBar = useMediaQuery({query: "only screen and (min-width : 900px)"});

  const collapseItems = [
    { label: 'Home', href: '/' },
		// { label: 'F3A', href: '/f3a-series' },
    { label: 'F4A', href: '/f4a-series' },
    { label: 'Formula Ford', href: '/ffa-series' },
    { label: 'S5000', href: '/s5000-series' },
    // { label: 'Asia-Pacific Junior Esports Challenge', href: '/apjc-series' },
    { label: 'Tri Nations Esports Cup', href: '/trinations-series' },
		// { label: 'News', href: '/news' },
    // { label: 'Sponsors', href: '/sponsors' },
		{ label: 'Privacy', href: '/about' },	
  ];
  if (route !== 'authenticated') collapseItems.push({ label: 'Sign In', href: '/signin' })
  if (route === 'authenticated') collapseItems.push({ label: 'Account', href: '/account' })
  if (route === 'authenticated') collapseItems.push({ label: 'Sign Out', href: '/' })


  const NavbarCollapse = () => {
    return (
      <>
        <Navbar.Collapse 
          css={{
            background: "black",
            filter: "opacity(90%)",
            backdropFilter: "none",
          }}
        > 
          {collapseItems.map((item, index) => (
            <Navbar.CollapseItem
              key={item.label}
              activeColor="primary"
              css={{
                color: index === collapseItems.length - 1 ? "$error" : awsui.colorTextLinkDefault,
              }}
              isActive={item.href === location.pathname}
              spellCheck={false}
            >
              <Link
                color="inherit"
                css={{
                  minWidth: "100%",
                }}
                key={item.label}
                onClick={ () => {
                  switch (item.label) {
                    case "Sign Out":
                      signOut();
                      break;
                  }
                  setSeriesContent("series")
                  navigate(item.href);
                  isSideMenuOpen && navbarToggleRef.current.click()
                }}
              >
                {item.label}
              </Link>
            </Navbar.CollapseItem>
          ))}
        </Navbar.Collapse>
      </>
    );
  }
  

  return (
    <>
    <NextUIProvider theme={nextUiTheme}>
        <Layout>
          <Navbar 
            variant="sticky" 
            {...density === Density.Comfortable ? {isCompact:false} : {isCompact:true}}
            css={{ 
              background: awsui.colorBackgroundCellShaded,
            }}
          >
            <Navbar.Brand>
              <Link
                onClick={ (event) => {
                  navigate("/")
                }}
              >
                <img
                  src={theme === Mode.Light ? headerLogoDark : headerLogoLight}
                  alt="FRG Header Logo"
                  style={{
                    width: "200px",
                    margin: "0px 50px 0px 0px"
                  }}
                />
              </Link>
            </Navbar.Brand>
            <Navbar.Content
              activeColor="primary"
              hideIn="xs"
              variant="underline"
            >
              <NavLinks />
            </Navbar.Content>
              <SpaceBetween direction="horizontal" size="l">
                <Navbar.Content>
                  {/* <SettingsMenu /> */}
                </Navbar.Content>
                <Navbar.Content
                >
                  <AuthContent />
                </Navbar.Content>
                <Navbar.Toggle
                  hidden={collapseNavBar} 
                  aria-label="toggle navigation" 
                  aria-controls="basic-navbar-nav"
                  ref={navbarToggleRef}
					        onChange={(isSelected) => {
                    setIsSideMenuOpen(isSelected as boolean)
                  }}
                >
                  <HamburgerIcon fill={awsui.colorTextBodyDefault} size={40} />
                </Navbar.Toggle>
              </SpaceBetween>
            <NavbarCollapse />
          </Navbar>
        </Layout>
      </NextUIProvider>
    </>
  );
}
